import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormField } from '@nuso/forms/data-access';
import * as _ from 'lodash';
import { Observable } from 'rxjs';

@Injectable()
export class ForminatorErrorService {
  private translateService = inject(TranslateService);


  errorMessage(field: FormField): string {
    const message = _.map(field.control.errors, (data, key) => {
      const additional = this.additionalErrorData(field, key, data);
      return this.translateService.instant(`validations.${key}`, { ...data,  ...additional });
    })

    return this.translateService.instant(field.label) + ' ' + message.join(', and ') + '.';
  }

  private additionalErrorData(field: FormField, validatorKey: string, validatorData: string ) {
    if (!field.validators) {
      return {};
    }
    const desc = field.validators[validatorKey];

    switch (validatorKey) {
      case 'rangeLength':
        return {
          minLength: desc[0],
          maxLength: desc[1]
        }
      default:
        return {
          desc
        };
    }

  }
}
